module.exports = __webpack_public_path__ + "img/cat-6.86afeb57.svg";